<template>
  <div class="about-page">
    <section class="about-hero">
      <div class="hero-background">
        <div class="hero-gradient"></div>
      </div>
      <div class="container">
        <div class="about-hero-content">
          <span class="subtitle">ABOUT US</span>
          <h1>About Photo Enhancer</h1>
          <p>Discover the story behind our AI-powered photo enhancement technology</p>
        </div>
      </div>
    </section>
    
    <section class="about-story">
      <div class="container">
        <div class="section-decoration">
          <span class="dot"></span>
          <span class="line"></span>
        </div>
        <div class="about-story-content">
          <div class="about-story-text">
            <span class="section-tag">OUR JOURNEY</span>
            <h2>Our Story</h2>
            <p>
              Photo Enhancer was founded with a simple mission: to help people preserve and enhance their precious memories. 
              We believe that every photo tells a story, and those stories deserve to be seen in the best possible quality.
            </p>
            <p>
              Revive your old photos with Photo Enhancer - AI upscale. Our tool can restore lost details and improve 
              the quality of your blurry or low-quality photos, making them look stunning and crystal-clear. With just a few clicks, 
              you can transform your photos into works of art and relive your cherished memories in better quality.
            </p>
            <p>
              Today, Photo Enhancer is used by thousands of people worldwide to transform their blurry, low-resolution photos 
              into stunning, high-definition images. We're proud to help preserve memories and bring joy to our users by 
              breathing new life into their cherished photographs.
            </p>
          </div>
          <div class="about-story-image">
            <div class="image-frame">
              <img src="../assets/英语3.png" alt="Our Story" class="optimized-image" />
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <section class="about-mission">
      <div class="container">
        <div class="section-decoration">
          <span class="dot"></span>
          <span class="line"></span>
        </div>
        <div class="section-header">
          <span class="section-tag">WHAT DRIVES US</span>
          <h2>Our Mission & Values</h2>
        </div>
        <div class="mission-values-grid">
          <div class="mission-value-card">
            <div class="mission-value-icon">🎯</div>
            <h3>Our Mission</h3>
            <p>To make photo enhancement technology accessible to everyone, helping people preserve their memories in the highest quality possible.</p>
          </div>
          
          <div class="mission-value-card">
            <div class="mission-value-icon">💡</div>
            <h3>Innovation</h3>
            <p>We continuously push the boundaries of AI technology to deliver the best photo enhancement results possible.</p>
          </div>
          
          <div class="mission-value-card">
            <div class="mission-value-icon">🤝</div>
            <h3>User-Focused</h3>
            <p>Everything we do is centered around providing value and an exceptional experience to our users.</p>
          </div>
          
          <div class="mission-value-card">
            <div class="mission-value-icon">🔒</div>
            <h3>Privacy & Security</h3>
            <p>We treat your photos with the utmost care, ensuring they remain private and secure at all times.</p>
          </div>
          
          <div class="mission-value-card">
            <div class="mission-value-icon">🌟</div>
            <h3>Quality Excellence</h3>
            <p>We are committed to delivering the highest quality results with every photo enhancement, ensuring your memories look their absolute best.</p>
          </div>
          
          <div class="mission-value-card">
            <div class="mission-value-icon">🚀</div>
            <h3>Continuous Improvement</h3>
            <p>We're constantly refining our technology and services based on user feedback to provide an ever-improving photo enhancement experience.</p>
          </div>
        </div>
      </div>
    </section>
    
    <section class="about-product">
      <div class="container">
        <div class="section-decoration">
          <span class="dot"></span>
          <span class="line"></span>
        </div>
        <div class="section-header">
          <span class="section-tag">WHAT WE OFFER</span>
          <h2>Product Introduction</h2>
        </div>
        <div class="product-description">
          <p>
            With Photo enhancer's AI photo enhancer, you can easily restore your old photos and bring them back to life with stunning HD quality. 
            Preserve your cherished memories and relive them in crystal-clear detail with AI upscale's AI photo enhancer - the best tool to improve 
            the quality of your photos.
          </p>
          <p>
            Don't settle for less than perfect photos. Use Photo enhancer's AI photo enhancer to fix blurry or low-quality photos and transform 
            them into stunning works of art. Whether it's a blurry selfie or an old family photo, AI upscale's AI photo enhancer can improve the 
            quality and restore the details you thought were lost forever.
          </p>
          <p>
            Make your photos pop with Photo enhancer's AI photo enhancer! With just a few clicks, you can enhance the quality of your photos and 
            make them look like they were taken by a professional. Introducing Photo enhancer - AI upscale, the AI Photo Enhancer that restores 
            and enhances your pixelated, blurry, and damaged photos to better quality. With Photo enhancer - AI upscale, your cherished memories 
            will no longer be blurred or low-quality.
          </p>
        </div>
      </div>
    </section>
    
    <section class="about-technology">
      <div class="container">
        <div class="section-decoration">
          <span class="dot"></span>
          <span class="line"></span>
        </div>
        <div class="about-technology-content">
          <span class="section-tag">OUR INNOVATIONS</span>
          <h2>Our Technology</h2>
          <p class="section-subtitle">The cutting-edge AI behind our photo enhancement solutions</p>
          
          <div class="technology-features">
            <div class="technology-feature">
              <div class="technology-feature-icon">📷</div>
              <div class="technology-feature-content">
                <h3>Photo Enhancer</h3>
                <p>Revive old photos with AI photo sharpener that enhances and restores blurry images to high-definition quality.</p>
              </div>
            </div>
            
            <div class="technology-feature">
              <div class="technology-feature-icon">⬆️</div>
              <div class="technology-feature-content">
                <h3>AI Upscale</h3>
                <p>Upgrade vintage or old phone photos to look like they were taken with the latest devices, and convert blurred photos to clear digital images.</p>
              </div>
            </div>
            
            <div class="technology-feature">
              <div class="technology-feature-icon">🔍</div>
              <div class="technology-feature-content">
                <h3>Image Upscaler</h3>
                <p>Revive compressed, damaged, or low-resolution photos with free intelligent restoration, including deblurring for high-resolution, high-definition results.</p>
              </div>
            </div>
            
            <div class="technology-feature">
              <div class="technology-feature-icon">✨</div>
              <div class="technology-feature-content">
                <h3>Image Enhancer</h3>
                <p>Easily restore damaged photos such as scratches and creases; Remove noise and pixels from photos, eliminating noise in photos while preserving low-resolution images.</p>
              </div>
            </div>
            
            <div class="technology-feature">
              <div class="technology-feature-icon">🖼️</div>
              <div class="technology-feature-content">
                <h3>Image Quality Enhancer</h3>
                <p>Improve photo quality with AI-powered noise reduction and smoothing, colorize old photos in high-definition, and remove blur with Remini.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style lang="scss" scoped>
/* 全局变量 */
:root {
  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  --secondary-gradient: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  --text-gradient: linear-gradient(135deg, #333 0%, #666 100%);
  --section-spacing: 120px;
  --card-radius: 16px;
  --transition-smooth: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

/* 通用样式 */
.section-decoration {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
  
  .dot {
    width: 12px;
    height: 12px;
    background: var(--primary-gradient);
    border-radius: 50%;
    margin-bottom: 8px;
  }
  
  .line {
    width: 60px;
    height: 3px;
    background: var(--primary-gradient);
  }
}

.section-tag {
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 2px;
  color: var(--primary-color);
  margin-bottom: 15px;
  position: relative;
  padding-left: 30px;
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 20px;
    height: 2px;
    background: var(--primary-gradient);
    transform: translateY(-50%);
  }
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  
  h2 {
    font-size: 2.8rem;
    font-weight: 800;
    background: var(--text-gradient);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 0;
  }
}

/* 英雄部分样式 */
.about-hero {
  position: relative;
  padding: 180px 0 120px;
  color: white;
  text-align: center;
  overflow: hidden;
  
  .hero-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    
    .hero-gradient {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
    }
  }
  
  .about-hero-content {
    max-width: 800px;
    margin: 0 auto;
    
    .subtitle {
      display: inline-block;
      font-size: 1rem;
      font-weight: 700;
      letter-spacing: 3px;
      background: white;
      color: #182848;
      padding: 8px 16px;
      border-radius: 30px;
      margin-bottom: 30px;
    }
    
    h1 {
      font-size: 4rem;
      font-weight: 800;
      margin-bottom: 25px;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
      line-height: 1.2;
    }
    
    p {
      font-size: 1.4rem;
      max-width: 700px;
      margin: 0 auto;
      opacity: 0.9;
      line-height: 1.6;
    }
  }
}

/* 故事部分样式 */
.about-story {
  padding: var(--section-spacing) 0;
  
  .about-story-content {
    display: flex;
    align-items: center;
    gap: 80px;
    
    .about-story-text {
      flex: 1;
      
      h2 {
        font-size: 2.8rem;
        font-weight: 800;
        margin-bottom: 30px;
        background: var(--text-gradient);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      
      p {
        font-size: 1.1rem;
        line-height: 1.8;
        color: #555;
        margin-bottom: 25px;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    
    .about-story-image {
      flex: 0 0 40%;
      max-width: 400px;
      
      .image-frame {
        position: relative;
        padding: 15px;
        background: white;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        border-radius: var(--card-radius);
        transform: rotate(2deg);
        transition: var(--transition-smooth);
        
        &::before {
          content: '';
          position: absolute;
          top: -10px;
          left: -10px;
          right: -10px;
          bottom: -10px;
          border: 2px solid var(--primary-color);
          border-radius: var(--card-radius);
          opacity: 0;
          transition: var(--transition-smooth);
          z-index: -1;
        }
        
        &:hover {
          transform: rotate(0) translateY(-15px);
          
          &::before {
            opacity: 0.3;
          }
        }
        
        .optimized-image {
          width: 100%;
          height: auto;
          border-radius: calc(var(--card-radius) - 10px);
          display: block;
        }
      }
    }
  }
}

/* 使命部分样式 */
.about-mission {
  padding: var(--section-spacing) 0;
  background-color: #f8f9fa;
  
  .mission-values-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    
    @media (max-width: 1200px) {
      grid-template-columns: repeat(2, 1fr);
    }
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
    
    .mission-value-card {
      background: white;
      border-radius: var(--card-radius);
      padding: 40px 30px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
      transition: var(--transition-smooth);
      position: relative;
      overflow: hidden;
      z-index: 1;
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 5px;
        background: var(--primary-gradient);
        transition: var(--transition-smooth);
      }
      
      &:hover {
        transform: translateY(-15px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        
        &::before {
          height: 10px;
        }
        
        .mission-value-icon {
          transform: scale(1.2);
        }
      }
      
      .mission-value-icon {
        font-size: 3rem;
        margin-bottom: 25px;
        transition: var(--transition-smooth);
      }
      
      h3 {
        font-size: 1.5rem;
        font-weight: 700;
        margin-bottom: 15px;
        color: #333;
      }
      
      p {
        font-size: 1rem;
        line-height: 1.7;
        color: #666;
      }
    }
  }
}

/* 产品介绍部分样式 */
.about-product {
  padding: var(--section-spacing) 0;
  
  .product-description {
    max-width: 900px;
    margin: 0 auto;
    position: relative;
    
    &::before {
      content: '"';
      position: absolute;
      top: -60px;
      left: -40px;
      font-size: 150px;
      color: rgba(0, 0, 0, 0.05);
      font-family: Georgia, serif;
      line-height: 1;
    }
    
    p {
      font-size: 1.15rem;
      line-height: 1.9;
      margin-bottom: 30px;
      color: #555;
      position: relative;
      padding-left: 20px;
      border-left: 3px solid var(--primary-color);
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

/* 技术部分样式 */
.about-technology {
  padding: var(--section-spacing) 0;
  background-color: #f8f9fa;
  
  .about-technology-content {
    text-align: center;
    
    h2 {
      font-size: 2.8rem;
      font-weight: 800;
      margin: 15px 0 20px;
      background: var(--text-gradient);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    
    .section-subtitle {
      font-size: 1.2rem;
      color: #666;
      max-width: 700px;
      margin: 0 auto 60px;
    }
    
    .technology-features {
      display: flex;
      flex-direction: column;
      gap: 40px;
      max-width: 900px;
      margin: 0 auto;
      
      .technology-feature {
        display: flex;
        align-items: flex-start;
        text-align: left;
        background-color: white;
        border-radius: var(--card-radius);
        padding: 40px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        transition: var(--transition-smooth);
        position: relative;
        overflow: hidden;
        
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 3px;
          background: var(--primary-gradient);
          transition: var(--transition-smooth);
        }
        
        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          
          &::after {
            width: 100%;
          }
          
          .technology-feature-icon {
            transform: scale(1.2) rotate(10deg);
          }
        }
        
        .technology-feature-icon {
          font-size: 2.5rem;
          margin-right: 30px;
          flex-shrink: 0;
          transition: var(--transition-smooth);
        }
        
        .technology-feature-content {
          h3 {
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 15px;
            color: #333;
          }
          
          p {
            font-size: 1.05rem;
            line-height: 1.7;
            color: #666;
          }
        }
      }
    }
  }
}

/* 响应式样式 */
@media (max-width: 1200px) {
  :root {
    --section-spacing: 100px;
  }
  
  .about-hero {
    padding: 150px 0 100px;
    
    .about-hero-content {
      h1 {
        font-size: 3.5rem;
      }
      
      p {
        font-size: 1.3rem;
      }
    }
  }
  
  .section-header {
    h2 {
      font-size: 2.5rem;
    }
  }
}

@media (max-width: 992px) {
  :root {
    --section-spacing: 80px;
  }
  
  .about-hero {
    padding: 120px 0 80px;
    
    .about-hero-content {
      h1 {
        font-size: 3rem;
      }
      
      p {
        font-size: 1.2rem;
      }
    }
  }
  
  .about-story {
    .about-story-content {
      flex-direction: column;
      text-align: center;
      gap: 60px;
      
      .about-story-text {
        h2 {
          font-size: 2.5rem;
        }
        
        .section-tag {
          padding-left: 0;
          
          &::before {
            display: none;
          }
        }
      }
      
      .about-story-image {
        margin: 0 auto;
      }
    }
  }
  
  .section-header {
    h2 {
      font-size: 2.2rem;
    }
  }
}

@media (max-width: 768px) {
  :root {
    --section-spacing: 60px;
  }
  
  .about-hero {
    padding: 100px 0 60px;
    
    .about-hero-content {
      h1 {
        font-size: 2.5rem;
      }
      
      p {
        font-size: 1.1rem;
      }
    }
  }
  
  .about-story {
    .about-story-content {
      .about-story-text {
        h2 {
          font-size: 2.2rem;
        }
        
        p {
          font-size: 1rem;
        }
      }
    }
  }
  
  .about-technology {
    .about-technology-content {
      h2 {
        font-size: 2.2rem;
      }
      
      .section-subtitle {
        font-size: 1.1rem;
      }
      
      .technology-features {
        .technology-feature {
          padding: 30px;
          flex-direction: column;
          
          .technology-feature-icon {
            margin: 0 0 20px 0;
          }
          
          .technology-feature-content {
            h3 {
              font-size: 1.3rem;
              text-align: center;
            }
            
            p {
              text-align: center;
            }
          }
        }
      }
    }
  }
  
  .about-product {
    .product-description {
      &::before {
        display: none;
      }
      
      p {
        font-size: 1rem;
        padding-left: 15px;
      }
    }
  }
}
</style> 